var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "clearfix main_center",
    },
    [
      _c("div", { staticClass: "top-content" }, [
        _c(
          "div",
          { staticClass: "left-navbar" },
          [
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "0" },
                attrs: { size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.back()
                  },
                },
              },
              [_vm._v("返回")]
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-right": "10px" },
                attrs: { type: "primary", size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.save()
                  },
                },
              },
              [_vm._v("保存")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "right-content clearfix" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              style: { height: _vm.cardMinHeight },
              attrs: {
                "label-width": "120px",
                model: _vm.form,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-card",
                {
                  staticClass: "box-card",
                  staticStyle: { position: "relative" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("面部信息")])]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "errorMsgPos",
                      staticStyle: { width: "100%" },
                      attrs: { label: "人员头像：", prop: "imgUrl" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            height: "360px",
                            "text-align": "center",
                          },
                        },
                        [
                          _c("img", {
                            style: {
                              "margin-top":
                                _vm.form.imgUrl != "" ? "0px" : "80px",
                            },
                            attrs: {
                              src: _vm.form.imgUrl || _vm.defaultImg,
                              alt: "",
                            },
                          }),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "20px",
                                left: "calc(50% - 72px)",
                              },
                              attrs: {
                                type: "default",
                                icon: "el-icon-camera",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.cameraDialogVisible = true
                                },
                              },
                            },
                            [_vm._v("面部信息录入")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                {
                  staticClass: "box-card",
                  staticStyle: { "margin-bottom": "0px" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("人员信息")])]
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "姓名：", prop: "personName" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "6",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.personName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "personName", $$v)
                                  },
                                  expression: "form.personName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "身份证号：", prop: "idcard" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "18",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.idcard,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "idcard", $$v)
                                  },
                                  expression: "form.idcard",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "角色：", prop: "roleType" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: "",
                                    "value-key": "value",
                                  },
                                  model: {
                                    value: _vm.form.roleType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "roleType", $$v)
                                    },
                                    expression: "form.roleType",
                                  },
                                },
                                _vm._l(_vm.roleList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CameraDialog", {
        attrs: { dialogVisible: _vm.cameraDialogVisible },
        on: {
          "update:dialogVisible": function ($event) {
            _vm.cameraDialogVisible = $event
          },
          "update:dialog-visible": function ($event) {
            _vm.cameraDialogVisible = $event
          },
          dialogCancle: _vm.dialogCancleCamera,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }